import { render, staticRenderFns } from "./ManageSpecialists.vue?vue&type=template&id=1a86b91f"
import script from "./ManageSpecialists.vue?vue&type=script&lang=js"
export * from "./ManageSpecialists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports